
import { defineComponent, computed, getCurrentInstance, reactive, onMounted} from 'vue';
import AppHeader from '@/components/Header.vue';
import { Rate, Field } from 'vant'
import { useStore } from 'vuex';

export default defineComponent({
  components: {
    AppHeader,
    VanRate: Rate,
    VanField: Field,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const store = useStore()
    const eveluateData = reactive({
      stars: 0,
      describe: '',
      created_at: '',
    })
    const pagePaddingTop = computed(() => {
      return store.getters.pagePaddingTop || 44
    })
    onMounted(() => {
      eveluateData.stars = Number((proxy.$route.query as any).score as number);
      let describe = '';
      try {
        describe = decodeURIComponent((proxy.$route.query as any).appraise);
      } catch (error) {
        describe = (proxy.$route.query as any).appraise;
      }
      try {
        describe = decodeURIComponent((proxy.$route.query as any).appraise);
      } catch (error) {
        describe = (proxy.$route.query as any).appraise;
      }
      eveluateData.describe = describe;
      eveluateData.created_at = (proxy.$route.query as any).created_at || '';
    })
    return {
      pagePaddingTop,
      eveluateData
    }
  },
})
